(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
      this.wrapper = null;
      this.content = null;
      this.originalItems = null;
      this.clonedItems = null;
      this.resizeObserver = null;
      this.resizeTimeout = null;
      this.isInitialized = false;
      this.animationFrame = null;
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      this.wrapper = this.querySelector('[ref="wrapper"]');
      this.content = this.querySelector('[ref="content"]');
      this.originalItems = this.querySelector('[ref="marqueeItems[]"]');
      
      if (!this.wrapper || !this.content || !this.originalItems) {
        console.error('Marquee: Required elements not found');
        return;
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.init();
          this.setupResizeObserver();
        });
      });
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }
    }

    init() {
      if (!this.originalContent) {
        this.originalContent = this.originalItems.cloneNode(true);
      }

      const existingClones = this.content.querySelectorAll('[ref="marqueeItems[]"]:not(:first-child)');
      existingClones.forEach(clone => clone.remove());

      this.content.style.animation = 'none';
      this.wrapper.style.animation = 'none';

      void this.content.offsetWidth;
      void this.wrapper.offsetWidth;

      this.clonedItems = this.originalItems.cloneNode(true);
      this.clonedItems.removeAttribute('ref');
      this.content.appendChild(this.clonedItems);

      this.animationFrame = requestAnimationFrame(() => {
        this.calculateSpeed();
        this.isInitialized = true;
      });
    }

    calculateSpeed() {
      const speedFactor = parseFloat(this.dataset.speedFactor) || 25;
      const contentWidth = this.originalItems.offsetWidth;
      
      if (contentWidth === 0 || !contentWidth) {
        setTimeout(() => {
          if (this.isConnected) {
            this.calculateSpeed();
          }
        }, 100);
        return;
      }

      const duration = contentWidth / speedFactor;
      this.style.setProperty('--marquee-speed', `${Math.max(duration, 1)}s`);

      this.content.style.animation = '';
      this.wrapper.style.animation = '';
    }

    setupResizeObserver() {
      let lastWidth = this.offsetWidth;

      this.resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const newWidth = entry.contentRect.width;
          
          if (Math.abs(newWidth - lastWidth) > 10) {
            lastWidth = newWidth;
            
            if (this.resizeTimeout) {
              clearTimeout(this.resizeTimeout);
            }
            
            this.resizeTimeout = setTimeout(() => {
              if (this.isConnected) {
                this.handleResize();
              }
            }, 200);
          }
        }
      });

      this.resizeObserver.observe(this);
    }

    handleResize() {
      this.isInitialized = false;
      this.init();
    }
  }

  if (!customElements.get('marquee-component')) {
    customElements.define('marquee-component', MarqueeComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
